import funbankComponents from '@styles/css-modules/apps/funbank';
import bancoGeneralComponents from '@styles/css-modules/apps/banco-general';
import interbankComponents from '@styles/css-modules/apps/interbank';
export function getCssModulesServer() {
  const appConfig = process.env.NEXT_PUBLIC_APP_CONFIG;
  switch (appConfig) {
    case "funbank":
      return funbankComponents;
    case "banco-general":
      return bancoGeneralComponents;
    case "interbank":
      return interbankComponents;
    default:
      return funbankComponents;
    // fallback
  }
}